module.exports = __webpack_public_path__ + "img/productBgImg12.5efb37c1.png";